export class User {
    id?: string;
    access?: {
        impersonate: boolean;
        manage: boolean;
        manageGroupMembership: boolean;
        mapRoles: boolean;
        view: boolean;
    };
    attributes?: {
        locale: Array<string>;
        merchantId?: Array<number>;
        supplierId?: Array<number>;

    };
    createdTimestamp?: number;
    disableableCredentialTypes?: Array<string>;
    email: string;
    emailVerified?: boolean;
    enabled?: boolean;
    firstName: string;
    lastName: string;
    notBefore?: string;
    requiredActions?: Array<string>;
    totp?: boolean;
    username: string;
    roles?: Array<string>;
    role?: string;
    credentials?: {
        type: string;
        value: string;
        temporary?: boolean;
    }
}